import * as React from "react";
import { showErrorAlert } from "src/loaders/NotificationLoader";
import { showHideLoadingDiv } from "src/loaders/StyleLoader";
import { ContactModel } from "src/models/contact-models";
import { InsertContact } from "src/server/utils/contact-utils";
import { isOntologyExist, redirectBackToApp, replaceSpaces } from "src/server/utils/general-utils";
import { Twilio } from "src/server/utils/twilio-utils";
import CustomModalDialog from "../Shared/Dialogs/CustomModalDialog";
import TermsAndConditions from "./TermsAndConditions";


interface Props {
    instance: string;
}

interface State {
    Contact: ContactModel;

}

class RegisterUser extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            Contact: Object()
        }
        this.handleContactForm = this.handleContactForm.bind(this);
    }

    handleContactForm(e) {
        let Contact = this.state.Contact;
        let name = e.target.name;
        if (name && name.length > 0 && name == "contact") { e.target.value = e.target.value.replace(new RegExp(" ", 'g'), ""); }
        if (e.target.type == "radio") {
            Contact[`${name}`] = e.target.checked;
        } else {
            Contact[`${name}`] = e.target.value;
        }
        this.setState({
            Contact
        });
    }

    async saveContact(noRedirect?: boolean) {
        const { Contact } = this.state;
        let { instance } = this.props;
        let isUserExist = await isOntologyExist(replaceSpaces(Contact.contact), ["Contact"]);
        if (Contact.password !== Contact.confirmPassword) {
            showErrorAlert("Passwords don't match.");
        }
        else if (Contact.mobile == "" || Contact.mobile.length > 15) {
            showErrorAlert("Enter Correct Mobile Format");
        }
        else {
            if (!isUserExist) {
                if (Contact) {
                    showHideLoadingDiv(true);
                    const newUser = await InsertContact("", Contact, false, instance);
                    showHideLoadingDiv(false);

                    if (newUser._id) {
                        const twilio = new Twilio();
                        let messageBody = "";
                        messageBody = `Thank you for joining the ONIT Network! Your number has been associated with username: ${Contact.contact}. To Unsubscribe to these messages, visit ${window.location.origin}/#${instance}/UnsubscribeSMSAlerts/FullScreen or contact your supervisor.`
                        twilio.SendSMS(Contact.mobile, messageBody, instance, (message) => { });
                        redirectBackToApp("GuestAccess")
                    } else {
                        alert("User registration failed.");
                    }
                }
            }
            else {
                alert("user already exists, please change user name");
            }
        }
    }

    render() {
        const { } = this.props;
        const { Contact } = this.state;

        const isValidData = Contact.contact &&
            Contact.name &&
            Contact.mobile &&
            Contact.email && true;

        return (
            <div className="container">
                <div className="card" id="divLogin">
                    <div className="divimg"><img id="profile-img" className="companyLogo" src="assets/img/new logo.png" /></div>
                    <p id="profile-name" className="profile-name-card"></p>
                    <div className="card">
                        <div className="container-fluid padding-10">
                            <div className="row padding-10">
                                <div className="col-md-12">
                                    <div className="col-md-2">
                                        <div className="form-group">
                                            <label htmlFor="name">Name</label>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <input type="text" id="name" name="name" className={`${Contact.name ? "" : "addFieldValidate"} form-control`} value={Contact.name} onChange={(e) => this.handleContactForm(e)} />
                                    </div>
                                    <div className="col-md-2">
                                        <div className="form-group">
                                            <label htmlFor="mobile">Mobile #</label>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <input type="number" id="mobile" name="mobile" required className={`${Contact.mobile ? "" : "addFieldValidate"} form-control`} value={Contact.mobile} onChange={(e) => this.handleContactForm(e)} />
                                    </div>
                                </div>
                            </div>
                            <div className="row padding-10">
                                <div className="col-md-12">
                                    <div className="col-md-2">
                                        <div className="form-group">
                                            <label htmlFor="contact">User Name*</label>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <input type="text" id="contact" name="contact" className={`${Contact.contact ? "" : "addFieldValidate"} form-control`} value={Contact.contact} onChange={(e) => this.handleContactForm(e)} />
                                    </div>
                                </div>
                            </div>
                            <div className="row padding-10">
                                <div className="col-md-12">
                                    <div className="col-md-2">
                                        <div className="form-group">
                                            <label htmlFor="newpassword">Password</label>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <input type="password" id="newpassword" name="password" className={`${Contact.password ? "" : "addFieldValidate"} form-control`} value={Contact.password} onChange={(e) => this.handleContactForm(e)} />
                                    </div>
                                    <div className="col-md-2">
                                        <div className="form-group">
                                            <label htmlFor="confirmpass">Confirm Password</label>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <input type="password" id="confirmpass" name="confirmPassword" className={`${Contact.confirmPassword ? "" : "addFieldValidate"} form-control`} value={Contact.confirmPassword} onChange={(e) => this.handleContactForm(e)} />
                                    </div>
                                </div>
                            </div>
                            <div className="row padding-10">
                                <div className="col-md-12">
                                    <div className="col-md-2">
                                        <div className="form-group">
                                            <label htmlFor="email">Email</label>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <input type="text" id="email" name="email" className={`${Contact.email ? "" : "addFieldValidate"} form-control`} value={Contact.email} onChange={(e) => this.handleContactForm(e)} />
                                    </div>
                                    <div className="col-md-2">
                                        <div className="form-group">
                                            <label htmlFor="company">Company</label>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <input type="text" id="company" name="company" className="form-control" value={Contact.company} onChange={(e) => this.handleContactForm(e)} />
                                    </div>
                                </div>
                            </div>
                            <div className="row padding-10">
                                <div className="col-md-12">
                                    <div className="col-md-2">
                                        <div className="form-group">
                                            <label htmlFor="streetAddress">Address</label>
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <input type="text" id="streetAddress" name="streetAddress" className="form-control" placeholder="Street Address" value={Contact.streetAddress} onChange={(e) => this.handleContactForm(e)} />
                                    </div>
                                    <div className="col-md-2">
                                        <input type="text" id="city" name="city" className="form-control" placeholder="City" value={Contact.city} onChange={(e) => this.handleContactForm(e)} />
                                    </div>
                                    <div className="col-md-3">
                                        <input type="text" id="state" name="state" className="form-control" placeholder="State" value={Contact.state} onChange={(e) => this.handleContactForm(e)} />
                                    </div>
                                    <div className="col-md-2">
                                        <input type="text" id="zipcode" name="zipcode" className="form-control" placeholder="ZipCode" value={Contact.zipcode} onChange={(e) => this.handleContactForm(e)} />
                                    </div>
                                </div>
                            </div>
                            <div className="row padding-10">
                                <br />
                                <br />
                                <div className="col-md-12 center">
                                    <button disabled={!isValidData} className="btn btn-primary btn-fill" onClick={() => {
                                        // 
                                        document.getElementById("btnTnCDialog").click();
                                    }}><i className="fa fa-save"></i>Register</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <button type="button" id="btnTnCDialog" data-toggle="modal" data-target="#TnCDialog" style={{ display: "none" }}>.</button>
                <CustomModalDialog id={"TnCDialog"} onSaveButtonClick={() => { this.saveContact() }} saveButtonText={"Accept"} cancelButtonText={"Close"} isEditForm={true}
                    hideHeader={true} heading={""} showCancelButton={true} disableSaveButton={false}>
                    <div className="row" style={{ zIndex: 9999999999 }}>
                        <TermsAndConditions />
                    </div>
                </CustomModalDialog>
            </div>
        )
    }

}

export default RegisterUser;



// WEBPACK FOOTER //
// ./src/Components/People/RegisterUser.tsx